export default function Alert(theme) {
  // const isLight = theme.palette.mode === 'light';

  // const standardStyle = (color) => ({
  //   UserSelect: 'none !important'
  // backgroundColor: theme.palette.background.paper,
  // color: isLight ? theme.palette.grey[800] : theme.palette.grey[300],
  // border: isLight ? `1px solid ${theme.palette.grey[300]}` : `1px solid ${theme.palette.grey[700]}`,
  // '& .MuiAlert-icon': {
  //   color: theme.palette[color][isLight ? 'main' : 'light']
  // }
  // });

  // const filledStyle = (color) => ({
  //   color: theme.palette[color].contrastText
  // });

  // const outlinedStyle = (color) => ({
  //   color: theme.palette[color][isLight ? 'darker' : 'lighter'],
  //   border: `solid 1px ${theme.palette[color][isLight ? 'light' : 'dark']}`,
  //   backgroundColor: theme.palette[color][isLight ? 'lighter' : 'darker'],
  //   '& .MuiAlert-icon': {
  //     color: theme.palette[color][isLight ? 'main' : 'light']
  //   }
  // });

  return {
    MuiAlert: {
      defaultProps: {
        iconMapping: {
          // error: <MIcon icon={"info"} filled />,
          // info: <MIcon icon={"info"} filled />,
          // success: <MIcon icon={check} filled />,
          // warning: <MIcon icon={warning} filled />
        }
      },

      styleOverrides: {
        root: {
          alignItems: 'center'
        },
        message: {
          '& .MuiAlertTitle-root': {
            // marginBottom: theme.spacing(0.5)
          }
        },
        action: {
          padding: '0 16px',
          '& button:not(:first-of-type)': {
            marginLeft: theme.spacing(1)
          }
        }

        // standardInfo: standardStyle('info'),
        // standardSuccess: standardStyle('success'),
        // standardWarning: standardStyle('warning'),
        // standardError: standardStyle('error'),

        // filledInfo: filledStyle('info'),
        // filledSuccess: filledStyle('success'),
        // filledWarning: filledStyle('warning'),
        // filledError: filledStyle('error'),

        // outlinedInfo: outlinedStyle('info'),
        // outlinedSuccess: outlinedStyle('success'),
        // outlinedWarning: outlinedStyle('warning'),
        // outlinedError: outlinedStyle('error')
      }
    }
  };
}
